import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { dashboardRoutes } from './routes';
export class Dashboard {
  constructor() {
    _defineProperty(this, "routes", dashboardRoutes);
  }
  async getDashboardCarts() {
    return new Promise(resolve => setTimeout(() => {
      resolve([{
        chartType: 'barChart',
        data: [{
          name: 'Page A',
          uv: 690,
          pv: 800,
          amt: 1400
        }, {
          name: 'Page B',
          uv: 868,
          pv: 967,
          amt: 1506
        }, {
          name: 'Page C',
          uv: 1397,
          pv: 1098,
          amt: 989
        }, {
          name: 'Page D',
          uv: 1480,
          pv: 200,
          amt: 1228
        }, {
          name: 'Page E',
          uv: 1520,
          pv: 1108,
          amt: 1100
        }, {
          name: 'Page F',
          uv: 1400,
          pv: 680,
          amt: 1700
        }]
      }, {
        chartType: 'pieChart',
        data: [{
          name: 'Group A',
          value: 400
        }, {
          name: 'Group B',
          value: 300
        }, {
          name: 'Group C',
          value: 300
        }, {
          name: 'Group D',
          value: 200
        }]
      }, {
        chartType: 'lineChart',
        data: [{
          name: 'Page A',
          uv: 4000,
          pv: 2400,
          amt: 2400
        }, {
          name: 'Page B',
          uv: 3000,
          pv: 1398,
          amt: 2210
        }, {
          name: 'Page C',
          uv: 2000,
          pv: 9800,
          amt: 2290
        }, {
          name: 'Page D',
          uv: 2780,
          pv: 3908,
          amt: 2000
        }, {
          name: 'Page E',
          uv: 1890,
          pv: 4800,
          amt: 2181
        }, {
          name: 'Page F',
          uv: 2390,
          pv: 3800,
          amt: 2500
        }, {
          name: 'Page G',
          uv: 3490,
          pv: 4300,
          amt: 2100
        }]
      }]);
    }, 500));
  }
}